import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api, qs } from '../../lib/api.js'
import { Badge, Card, Empty, ErrorBox, Page, Spinner, StatusBadge, useAsync } from '../../components/Ui.jsx'
import { ORDER_FLOW, fmtDate, inr, lakh, statusLabel } from '../../lib/format.js'

const FILTERS = [
  ['open', 'Open'],
  ['awaiting_advance', 'Awaiting advance'],
  ['sample_dispatched', 'Sample out'],
  ['sample_failed', 'Failed samples'],
  ['payout_released', 'Ready to dispatch'],
  ['in_transit', 'In transit'],
  ['completed', 'Completed'],
  ['', 'Everything']
]

export default function Orders () {
  const [status, setStatus] = useState('open')
  const [urgent, setUrgent] = useState(false)
  const { data, error, loading, reload } = useAsync(
    () => api.get(`/operator/orders${qs({ status, urgent: urgent ? 1 : '' })}`),
    [status, urgent],
    { live: ['orders'] }
  )

  const orders = data?.orders || []

  return (
    <Page
      title="Orders"
      subtitle="Every booking the desk is carrying, oldest stocking date first."
      actions={<Link className="btn primary" to="/operator/match">New booking</Link>}
    >
      <Card padded={false}>
        <div className="filterbar">
          <div className="chips">
            {FILTERS.map(([v, label]) => (
              <button key={label} className={`chip ${status === v ? 'on' : ''}`} onClick={() => setStatus(v)}>{label}</button>
            ))}
            <button className={`chip ${urgent ? 'on' : ''}`} onClick={() => setUrgent(u => !u)}>Urgent only</button>
          </div>
          <div style={{ flex: 1 }} />
          <div className="muted small">{orders.length} order(s)</div>
        </div>

        {loading
          ? <Spinner />
          : error
            ? <div className="body"><ErrorBox error={error} onRetry={reload} /></div>
            : (
              <div className="scroll-x">
                <table>
                  <thead>
                    <tr>
                      <th>Order</th><th>Farmer</th><th>Hatchery</th><th>Stocking</th>
                      <th className="num">Qty</th><th className="num">Value</th><th>Progress</th><th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map(o => {
                      const step = ORDER_FLOW.indexOf(o.status)
                      return (
                        <tr key={o._id}>
                          <td>
                            <Link className="rowlink mono" to={`/operator/orders/${o._id}`}>{o.orderCode}</Link>
                            {o.isUrgent && <><br /><Badge tone="bad">urgent</Badge></>}
                          </td>
                          <td>{o.farmer?.name}<span className="t-sub">{o.farmer?.phone}</span></td>
                          <td>{o.hatchery?.name}<span className="t-sub mono">{o.batch?.batchCode}</span></td>
                          <td className="tight">{fmtDate(o.targetStockingDate)}<span className="t-sub">sample by {fmtDate(o.sampleDueDate)}</span></td>
                          <td className="num">{lakh(o.quantityLakh)}<span className="t-sub">{o.plStage}</span></td>
                          <td className="num">{inr(o.totalAmount)}</td>
                          <td className="small nowrap">
                            {step >= 0 ? `${step + 1} of ${ORDER_FLOW.length}` : <span className="muted">—</span>}
                          </td>
                          <td><StatusBadge status={o.status} /></td>
                        </tr>
                      )
                    })}
                    {!orders.length && <tr><td colSpan={8}><Empty>No orders in this view.</Empty></td></tr>}
                  </tbody>
                </table>
              </div>
              )}
      </Card>
    </Page>
  )
}
